import './CompensationHistorySearch.scss';
import { Button } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { Field  } from '../../models/home';
import { handleOnBlur, handleOnChangeDate, handleOnChangeText, handleOnValidateDate } from '../../helpers/form';
import { LANGUAGE, VALIDATION_TYPE } from '../../constants/common';
import { useTranslation } from 'react-i18next';
import AppDate from '../AppCommon/AppDate/AppDate';
import AppText from '../AppCommon/AppText/AppText';

interface Props {
    fields: Field[];
    searchButtonDisabled: boolean;
    handleOnClickClear: () => void;
    handleOnClickSearch: (pageNumber?: number) => void;
    setFields: Dispatch<SetStateAction<Field[]>>;
}

const CompensationHistorySearch = ({
    fields,
    searchButtonDisabled,
    handleOnClickClear,
    handleOnClickSearch,
    setFields
}: Props) => {
    const { i18n, t } = useTranslation();

    const handleOnClickLink = () => {
        if(i18n.language === LANGUAGE.en) {
            window.open('https://aircanada.sharepoint.com/sites/ACP-Policies-Procedures/SitePages/Universal%20-%20Call%20centers/674297.aspx','_blank');
        } else {
            window.open('https://aircanada.sharepoint.com/sites/ACP-Policies-Procedures/SitePages/Universal%20-%20Call%20centers/fr/674297.aspx','_blank');
        }
    };

    return (
        <div className="c-comp-hist-search">
            <div className="c-web">
                <AppText
                    label={t('labels.lastName')}
                    width={23.5}
                    error={fields[0].requiredError ? true : false}
                    helperText={fields[0].requiredError}
                    maxLength={52}
                    value={fields[0].value}
                    onChange={e => handleOnChangeText(e, 0, setFields, VALIDATION_TYPE.nonNumeric, [1, 2, 3])}
                />
                <AppDate
                    label={t('labels.date')}
                    width={23.5}
                    value={fields[1].value}
                    onChange={e => handleOnChangeDate(e, 1, setFields, [0, 2, 3])}
                    error={fields[1].error || fields[1].requiredError ? true : false}
                    helperText={fields[1].error ? fields[1].error : fields[1].requiredError ? fields[1].requiredError : 'DD/MM/YYYY'}
                    onError={e => handleOnValidateDate(e, 1, setFields, t('validations.date'))}
                />
                <AppText
                    label={t('labels.bookingReference')}
                    width={23.5}
                    error={fields[2].error || fields[2].requiredError ? true : false}
                    helperText={fields[2].error || fields[2].requiredError}
                    maxLength={6}
                    value={fields[2].value}
                    onBlur={e => handleOnBlur(e, 2, 6, t('validations.bookingReference'), setFields)}
                    onChange={e => handleOnChangeText(e, 2, setFields, VALIDATION_TYPE.alphaNumeric, [0, 1, 3], [3])}
                />
                <AppText
                    label={t('labels.ticketNum')}
                    width={23.5}
                    error={fields[3].error || fields[3].requiredError ? true : false}
                    helperText={fields[3].error || fields[3].requiredError}
                    maxLength={13}
                    value={fields[3].value}
                    onBlur={e => handleOnBlur(e, 3, 13, t('validations.ticketNumberMin'), setFields)}
                    onChange={e => handleOnChangeText(e, 3, setFields, VALIDATION_TYPE.numeric, [0, 1, 2], [2])}
                />
            </div>
            <div className="c-ipad">
                <AppText
                    label={t('labels.lastName')}
                    width={100}
                    error={fields[0].requiredError ? true : false}
                    helperText={fields[0].requiredError}
                    maxLength={52}
                    value={fields[0].value}
                    onChange={e => handleOnChangeText(e, 0, setFields, VALIDATION_TYPE.nonNumeric, [1, 2, 3])}
                />
                <AppDate
                    label={t('labels.date')}
                    width={100}
                    value={fields[1].value}
                    onChange={e => handleOnChangeDate(e, 1, setFields, [0, 2, 3])}
                    error={fields[1].error || fields[1].requiredError ? true : false}
                    helperText={fields[1].error ? fields[1].error : fields[1].requiredError ? fields[1].requiredError : 'DD/MM/YYYY'}
                    onError={e => handleOnValidateDate(e, 1, setFields, t('validations.date'))}
                />
                <AppText
                    label={t('labels.bookingReference')}
                    width={100}
                    error={fields[2].error || fields[2].requiredError ? true : false}
                    helperText={fields[2].error || fields[2].requiredError}
                    maxLength={6}
                    value={fields[2].value}
                    onBlur={e => handleOnBlur(e, 2, 6, t('validations.bookingReference'), setFields)}
                    onChange={e => handleOnChangeText(e, 2, setFields, VALIDATION_TYPE.alphaNumeric, [0, 1, 3])}
                />
                <AppText
                    label={t('labels.ticketNum')}
                    width={100}
                    error={fields[3].error || fields[3].requiredError ? true : false}
                    helperText={fields[3].error || fields[3].requiredError}
                    maxLength={13}
                    value={fields[3].value}
                    onBlur={e => handleOnBlur(e, 3, 13, t('validations.ticketNumberMin'), setFields)}
                    onChange={e => handleOnChangeText(e, 3, setFields, VALIDATION_TYPE.numeric, [0, 1, 4])}
                />
            </div>
            <div className="c-row">
                <div className="c-reminder">
                    <span className="bold">{t('labels.reminder')}</span>
                    <span>{t('labels.searchHistoryMsg')}</span>
                    <span
                        className="link--underline"
                        onClick={() => handleOnClickLink()}
                    >
                        {t('labels.searchHistoryMsgClickHere')}
                    </span>
                </div>
                <div className="c-btn">
                    <Button 
                        className="btn btn--secondary btn-clear"
                        onClick={handleOnClickClear}
                    >
                        {t('buttons.clear')}
                    </Button>
                    <Button
                        className="btn btn--primary btn-submit"
                        disabled={searchButtonDisabled}
                        onClick={() => handleOnClickSearch()}
                    >
                        {t('buttons.searchHistory')}
                    </Button>
                </div>
            </div>            
        </div>
    );
};

export default CompensationHistorySearch;